import { FormState, FormType } from '@zaoblako/web/shared/components/form-sidebar/models/form-state';
import { Subject } from 'rxjs';

export const formInitialState: FormType = {
  type: null,
  isShowSidebar: false,
  loading: false,
  isEdit: false,
  isShowDelete: false,
  isShowShare: false,
  entityId: null,
  headerText: null,
  isShowRedirectInCreate: true,
  isRedirectInCreate: true,
  widthSize: 'form-sidebar',
  typeZIndex: 'z-index-1000',
  data: null,
  onSave$: new Subject(),
  onDelete$: new Subject(),
  canWrite: true
};

export const formsInitialState: FormState = {
  forms: []
};
